import CustomAlert from '../reusable/CustomAlert';

export const SummaryFailedAlert = () => (
  <CustomAlert alertType="error" header="Your summary failed to generate">
    Summary generation failed - contact admin for support
  </CustomAlert>
);

export const SummaryUpdatingAlert = () => (
  <CustomAlert alertType="warning" header="Your summary is being updated">
    The latest summary information is being generated. Please check back in <strong>about 30 minutes</strong> to view
    the updated content.
  </CustomAlert>
);
